export default {
  render: function (h) {
    return (
      <el-dialog
        title={this.$i18n('Table display settings')}
        visible
        width="80%"
        beforeClose={this.handleCancel}
      >
        {
          this.tempSchema ? (
            <div>
              <el-radio
                label="sku_location"
                value={this.tempSchema}
                onInput={value => this.$emit('updateTempSchema', value)}
              />
              <el-radio
                label="uid"
                value={this.tempSchema}
                onInput={value => this.$emit('updateTempSchema', value)}
              />
            </div>
          ) : null
        }
        <p style={{ marginTop: 0 }}>
          {this.$i18n('Check / uncheck to change visibility, drag to change order:')}
        </p>
        <el-tree
          ref="tree"
          data={[...this.schema]}
          nodeKey="id"
          defaultCheckedKeys={this.schema.filter(t => t.visible).map(t => t.id)}
          defaultExpandAll
          draggable
          showCheckbox
          on-node-drop={this.handleDrop}
        />
        <div slot="footer">
          <el-button type="primary" on-click={this.confirm}>
            {this.$i18n('Confirm')}
          </el-button>
          <el-button on-click={this.handleCancel}>
            {this.$i18n('Cancel')}
          </el-button>
        </div>
      </el-dialog>
    )
  },
  props: ['schema', 'handleConfirm', 'handleCancel', 'tempSchema'],
  methods: {
    handleDrop(draggingNode, droppedNode, position) {
      const checked = draggingNode.checked
      if (position === 'inner' && droppedNode) {
        this.$refs.tree.remove(droppedNode.childNodes[0])
        this.$refs.tree.insertAfter(draggingNode.data, droppedNode)
      }
      if (checked) {
        this.$refs.tree.setChecked(draggingNode.data, true)
      }
    },
    confirm() {
      const o = {}
      const checkedKeys = this.$refs.tree.getCheckedKeys()
      for (const t of checkedKeys) {
        o[t] = true
      }
      const keys = this.$refs.tree.data.map(t => ({
        id: t.id,
        label: this.$i18n(t.label),
        visible: o[t.id]
      }))
      if (this.tempSchema) {
        keys.push({
          id: 'level',
          level: this.tempSchema
        })
      }
      this.handleConfirm(keys)
      this.handleCancel()
    }
  }
}



// WEBPACK FOOTER //
// ./packages/creator/ListView/column-edit-modal.js